export default __webpack_public_path__ + "assets/api-unhealthy-238671739a3cce11feb72f44c2d8f74c.svg";